import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import SCROLL_BUTTON from './scroll-button.palette-schema.yaml';

registerTileSchema(SCROLL_BUTTON);

export function generateScrollButton(TILE) {
    return {
        button: {
            ...resolveBackground(TILE.SCROLL_BUTTON_BG),
            width: 32,
            height: 32,
            alignSelf: 'center',
            borderRadius: TILE.SCROLL_BUTTON_RADIUS < 0 ? `${-TILE.SCROLL_BUTTON_RADIUS}%` : TILE.SCROLL_BUTTON_RADIUS,
        },
        icon: icon(TILE.SCROLL_BUTTON_ICON_COLOR),
    };
}

export function generateScrollButtonPane(TILE) {
    const SCROLL_BUTTON = generateScrollButton(TILE);

    return {
        rightScrollButton: {
            style: {
                base: {
                    ...SCROLL_BUTTON.button,
                },
            },
        },
        leftScrollButton: {
            style: {
                base: {
                    ...SCROLL_BUTTON.button,
                },
            },
        },
        rightScrollButtonIcon: SCROLL_BUTTON.icon,
        leftScrollButtonIcon: SCROLL_BUTTON.icon,
    };
}
